<template>
  <div>
    <v-btn text @click="back">
      <v-icon class="mr-1"> mdi-backspace </v-icon> BACK
    </v-btn>
  </div>
</template>
<script>
export default {
  props: ["name"],
  methods: {
    back(name) {
      this.$emit("back", name);
    },
  },
};
</script>
